import { TokenResponse } from '@sanlam-glacier/app-common/types/auth/token-response.type.js';
import { AuthStore, getLocalJwtFromSessionStorage } from 'auth';

export const getAuthHeader = (
  bffApiUrl: string,
  configureAccessToken: boolean | undefined = true,
  localJwtProvider: string | undefined,
  authToken?: TokenResponse | undefined
): string => {
  if (!configureAccessToken) return '';

  const token = authToken ?? AuthStore.getAuthToken();
  if (!token) return '';
  const isLocalJwtNeeded =
    (bffApiUrl.startsWith('http://localhost') || bffApiUrl.startsWith('https://localhost')) &&
    !!localJwtProvider;
  if (isLocalJwtNeeded) {
    const localJwtAuthHeader = getLocalJwtFromSessionStorage();
    return localJwtAuthHeader ?? '';
  }

  const gatewayAuthHeader = `${token.token_type} ${token.access_token}`;
  return gatewayAuthHeader;
};
